export default {"src":"/_next/static/media/pathways.02028e8a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};